export enum CreditCardStatus {
    Active = 1,
    Inactive = 2
}
